module.exports = __webpack_public_path__ + "static/media/lunch.2de29c29.svg";